import {LocalStorageType} from "./enums";
import enTranslations from "./translations/en.json";
import frTranslations from "./translations/fr.json";

const languages: Record<string, any> = {
    en: enTranslations,
    fr: frTranslations,
}

// default language
let translations = languages["en"];

// load other supported languages
const userLang = localStorage.getItem(`${LocalStorageType.UserLanguage}`);
if (userLang && languages[userLang]) {
    translations = Object.assign(translations, languages[userLang]);
}

export default {
    t: function(key: string): string {
        return translations[key] || key;
    }
}
